(() => {
  const KEY = 'ferdossi-poetry-entry-v1';
  let acceptedInMemory = false;
  function accepted() {
    if (acceptedInMemory) return true;
    try { return Number(localStorage.getItem(KEY)) > Date.now(); } catch (_) { return false; }
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-f-gate]').forEach((dialog) => {
      if (dialog.dataset.fInitialized || typeof dialog.showModal !== 'function') return;
      dialog.dataset.fInitialized = 'true';
      let poems;
      try { poems = JSON.parse(dialog.querySelector('[data-f-poems]').textContent); } catch (_) { return; }
      poems = poems.filter(p => p && typeof p.text === 'string' && p.text.trim());
      if (!poems.length) return;
      const status = dialog.querySelector('[data-f-status]');
      const titleId = dialog.getAttribute('aria-labelledby');
      const panes = dialog.querySelectorAll('[data-f-pane]');
      let oldOverflow = '';
      let previousFocus = null;
      let preview = false;
      function phase(name, focusSelector) {
        panes.forEach(p => {
          p.hidden = p.dataset.fPane !== name;
          if (!p.hidden) {
            p.style.animation = 'none';
            void p.offsetWidth;
            p.style.animation = '';
          }
        });
        dialog.classList.toggle('f-gate-reading', name !== 'question');
        const ids = {question:titleId,read:dialog.querySelector('[data-f-pane="read"] h2').id,success:dialog.querySelector('[data-f-success-title]').id};
        dialog.setAttribute('aria-labelledby', ids[name]);
        status.textContent = name === 'read' ? 'Una primera lectura.' : name === 'success' ? 'Lectura completada.' : '';
        if (focusSelector) dialog.querySelector(focusSelector).focus();
      }
      function open(isPreview = false) {
        if (dialog.open) return;
        preview = isPreview;
        previousFocus = document.activeElement;
        oldOverflow = document.body.style.overflow;
        phase('question');
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        dialog.querySelector('[data-f-yes]').focus();
      }
      function enter() {
        if (!preview) {
          acceptedInMemory = true;
          try { localStorage.setItem(KEY, String(Date.now() + Number(dialog.dataset.fDays || 30) * 86400000)); } catch (_) {}
        }
        dialog.close();
        document.body.style.overflow = oldOverflow;
        if (preview && previousFocus && previousFocus.isConnected) previousFocus.focus();
        else {
          const main = document.querySelector('#MainContent');
          if (main) {
            main.classList.remove('f-store-arrive');
            void main.offsetWidth;
            main.classList.add('f-store-arrive');
            main.focus({preventScroll:true});
          }
        }
      }
      dialog.addEventListener('cancel', event => { if (!preview) event.preventDefault(); });
      dialog.addEventListener('close', () => { document.body.style.overflow = oldOverflow; });
      dialog.querySelector('[data-f-yes]').addEventListener('click', enter);
      dialog.querySelector('[data-f-no]').addEventListener('click', () => {
        const poem = poems[Math.floor(Math.random() * poems.length)];
        dialog.querySelector('[data-f-poem]').textContent = poem.text;
        dialog.querySelector('[data-f-author]').textContent = [poem.author,poem.title,poem.fragment ? 'Fragmento' : ''].filter(Boolean).join(' · ');
        phase('read', '[data-f-read]');
      });
      dialog.querySelector('[data-f-read]').addEventListener('click', () => phase('success','[data-f-enter]'));
      dialog.querySelector('[data-f-enter]').addEventListener('click', enter);
      const previewButton = document.querySelector(`[data-f-preview="${dialog.id}"]`);
      if (previewButton) previewButton.addEventListener('click', () => open(true));
      if (!window.Shopify?.designMode && !accepted()) open();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const dialog = event.target.querySelector('[data-f-gate]');
    if (dialog?.open) dialog.close();
  });
})();


// Una luz suave sigue el puntero; se omite en dispositivos táctiles.
(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(pointer: fine)');
  let frame = 0;
  let point = null;
  function active() {
    return !motion.matches && finePointer.matches && !document.body.classList.contains('f-motion-off');
  }
  function reset() {
    document.documentElement.style.removeProperty('--f-light-x');
    document.documentElement.style.removeProperty('--f-light-y');
    document.documentElement.style.removeProperty('--f-tilt-x');
    document.documentElement.style.removeProperty('--f-tilt-y');
    point = null;
  }
  document.addEventListener('pointermove', event => {
    if (!active() || event.pointerType === 'touch') return;
    point = {x:event.clientX, y:event.clientY};
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (!point || !active()) { reset(); return; }
      const x = Math.max(0, Math.min(1, point.x / window.innerWidth));
      const y = Math.max(0, Math.min(1, point.y / window.innerHeight));
      const style = document.documentElement.style;
      style.setProperty('--f-light-x', `${Math.round(x * 100)}%`);
      style.setProperty('--f-light-y', `${Math.round(y * 100)}%`);
      style.setProperty('--f-tilt-x', `${(.5 - y) * 5}deg`);
      style.setProperty('--f-tilt-y', `${(x - .5) * 7}deg`);
    });
  }, {passive:true});
  document.documentElement.addEventListener('pointerleave', reset);
  motion.addEventListener('change', reset);
  finePointer.addEventListener('change', reset);
})();
